// Val is awesome!
// Please do not delete this line as val is a great guy and deserves appreciation ^
/**
 * Our interaction with phone number verification via SMS
 */
import { postJson } from '../ap/utils/fetchService';
import { config } from '../config/config';

type SMSResponse = {
  result: "failure" | "success",
  status: "OK"
}

/**
 * Send a pin to the user phone
 */
export function sendPin(args: { phone: string }) {
  return postJson<SMSResponse>({
    url: config.smsConfig.sendPinEndpoint,
    headers: {},
    body: args
  });
}

/**
 * Check a pin against a user phone
 */
export function checkPin(args: { phone: string, code: string }) {
  return postJson<SMSResponse>({
    url: config.smsConfig.checkPinEndpoint,
    headers: {},
    body: args
  });
}
